import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

type Error = {
  hasError?: boolean;
};

export const SlotTimeWrapper = styled("div")(({ hasError }: Error) => ({
  margin: "20px 8px",
  width: "100%",
  border: `1px solid ${hasError ? colors.error200 : colors.gray200}`,
  borderRadius: 8,
}));

export const SlotTimeHeader = styled("div")(({ hasError }: Error) => ({
  backgroundColor: hasError ? colors.error50 : colors.gray25,
  padding: 12,
  borderBottom: `1px solid ${hasError ? colors.error200 : colors.gray200}`,
}));

export const SlotTimeHeaderLabel = styled("span")({
  textTransform: "uppercase",
  color: colors.gray800,
  fontSize: 10,
  fontWeight: 700,
  lineHeight: "15px",
  fontFamily: "Manrope",
});

export const SlotTimeForm = styled("div")({
  padding: "12px 8px",
  backgroundColor: colors.gray50,
});

export const SlotTimeFooter = styled("div")(({ hasError }: Error) => ({
  padding: 8,
  borderTop: `1px solid ${hasError ? colors.error200 : colors.gray200}`,
  backgroundColor: hasError ? colors.error50 : colors.gray50,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
}));

export const IconButtonClose = styled(IconButton)({
  padding: "10px 5px !important",
});

export const ErrorWrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  marginRight: 8,
});

export const ErrorMessage = styled("span")({
  color: colors.error500,
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "16px",
  fontFamily: "Manrope",
});
